import type { KeySignatureDisplay } from 'Seeds/ExerciseContent/scaleNotation';
import { SETTINGS_REGISTRY } from 'Settings/settingsRegistry';
import type { PerUserDevicePersistence } from 'Settings/settingTypes';
import { usePerUserDeviceSettingSync } from 'Settings/usePerUserDeviceSettingSync';
import { keySignatureDisplayHydrated } from './keySignatureDisplaySlice';
import { keySignatureDisplayStore } from './keySignatureDisplayStorage';

/** How the key-signature display setting is kept: per user, on the device. */
export const keySignatureDisplayPersistence: PerUserDevicePersistence<KeySignatureDisplay> = {
  store: keySignatureDisplayStore,
  hydrate: keySignatureDisplayHydrated,
};

/**
 * Keeps the key-signature display setting in step with the signed-in user: loads
 * the user's saved setting into Redux whenever the user changes, and saves each
 * change to that user's storage. Mount once, near the top of the app. The work
 * is the settings model's per-user device sync, run for this setting.
 */
export function useKeySignatureDisplaySync(userId: string | undefined): void {
  usePerUserDeviceSettingSync(
    SETTINGS_REGISTRY.keySignatureDisplay,
    keySignatureDisplayPersistence,
    userId,
  );
}
